import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDisputes } from 'services/glass-management/glassManagement';

export const fetchDisputes = createAsyncThunk('glass/dispute/fetch', async (filters) => {
    const res = await getDisputes(filters.start, filters.end);
    return { data: res };
});

export const disputeSlice = createSlice({
    name: 'glassDispute',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchDisputes.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDisputes.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchDisputes.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load dispute data!';
                state.data = null;
            });
    }
});

export default disputeSlice.reducer;
